import Tooltip, {TooltipProps, tooltipClasses} from '@mui/material/Tooltip';
import {styled} from "@material-ui/styles";
import React from "react";
import {FormDataBookingItem} from "./FormDataBookingItem";
import {CheckBoxTerms} from "components/CheckBoxTerms";
import {Spinner} from 'reactstrap'
import {useBuyerUser} from '../../hooks/useBuyerUser'
import {useLocation} from 'react-router-dom'
import {useInitIdioma} from '../../customHooks/useInitIdioma'
import {ActionPayment} from './CartPage'

interface Props {
  items: { name: string, required: boolean, placeholder: string }[]
  values: { [name: string]: string }

  onClick(isAgency: boolean, action: ActionPayment): void

  handleChange(name: string, value)

  t: any
  disabled: boolean
  datosPersonales: boolean
  carrito: boolean
  expired?: boolean
  adding?: boolean
  loading
  loadedExists
  publicToken
  client
  checked
  handleChangeCheked
  existsTerms
  clickTerminos
  // additionalRequiredInformation
  setTelephoneFormat
}

export const FormDataBooking = (props: Props) => {
  const {
    adding,
    items,
    values,
    onClick,
    handleChange,
    t,
    disabled,
    datosPersonales,
    carrito,
    expired,
    loading,
    loadedExists,
    publicToken,
    client,
    checked,
    handleChangeCheked,
    existsTerms,
    clickTerminos,
    // additionalRequiredInformation,
    setTelephoneFormat
  } = props

  const onChange = (event) => {
    handleChange(event.target.name, event.target.value)
  }

  const location = useLocation()
  const {isAgency} = useBuyerUser(publicToken, location.search, location.pathname)
  
  return (
    <>
      <h4 className="tramoSeleccionado">{t("bookingDetails")}</h4>
      {/*<DataBuyerHeader
        dataBuyer={dataBuyer}
      />*/}

      <div className="row centrado">
        <div className="col-sm-8">
          {
            items.map(item => (
              <FormDataBookingItem
                key={item.name}
                name={item.name}
                value={values[item.name]}
                placeholder={item.required? '* ' + item.placeholder : item.placeholder}
                required={item.required}
                onChange={onChange}
                t={t}
                // additionalRequiredInformation={additionalRequiredInformation}
                setTelephoneFormat={setTelephoneFormat}
              />
            ))
          }

          {!loading && loadedExists &&
          <CheckBoxTerms
            publicToken={publicToken}
            client={client}
            checked={checked}
            handleChangeCheked={handleChangeCheked}
            existsTerms={existsTerms}
            clickTerminos={clickTerminos}
          />
          }
        </div>
        <div className="col-sm-4 centrado" style={{/*padding: '50px'*/}}>
          {disabled &&
            <HtmlTooltip
              title={
                <React.Fragment>
                  <ul>
                    {!carrito && <li>{t("noCart")}</li>}
                    {!datosPersonales && <li>{t("noData")}</li>}
                    {!checked && <li>{t("noTerms")}</li>}
                    {expired && <li>{t("expiredItems")}</li>}
                  </ul>
                </React.Fragment>
              }
              placement="top"
            >
              <span className="btn btn-huge btn-block btn-large">
                  {!isAgency && <button
                    style={{textDecorationColor: 'white'}} disabled={disabled}
                    type="submit"
                    className="btn btn-huge sobredimensionado btn-block btn-large bg-blue-t0 text-white"
                    onClick={() => onClick(isAgency, ActionPayment.pay)}>{t("book")}
                  </button>}
                  {isAgency && <PaymentButtons
                    disabled={disabled}
                    isAgency={isAgency}
                    onClick={(isAgency, action) => onClick(isAgency, action)}
                  />}
              </span>
  
            </HtmlTooltip>
          }
          {!disabled &&
            <span
              className="btn btn-huge btn-block btn-large">
              {!adding && !isAgency &&
              <button
                disabled={disabled}
                type="submit"
                className="btn sobredimensionado btn-block btn-large bg-blue-t0 text-white-t0"
                onClick={() => onClick(isAgency, ActionPayment.pay)}>{t("book")}
              </button>
              }
              {!adding && isAgency &&
              <PaymentButtons
                disabled={disabled}
                isAgency={isAgency}
                onClick={(isAgency, action) => onClick(isAgency, action)}
              />
              }
              {adding && 
                <Spinner/>
              }
            </span>
          }
        </div>
      </div>
    </>
  )
}

interface PaymentButtonsProps {
  isAgency: boolean
  disabled: boolean
  onClick: (isAgency: boolean, action: ActionPayment) => void
}

const PaymentButtons: React.FC<PaymentButtonsProps> = ({isAgency, onClick, disabled}) => {

  const {t} = useInitIdioma()
  
  if (isAgency) {
    return (
      <div style={{
        display: "flex",
        flexDirection: "column",
      }}>
        <button
          disabled={disabled}
          type="submit"
          className="btn  btn-block bg-blue-t0 text-white-t0 mb-5"
          onClick={() => onClick(isAgency, ActionPayment.buyDue)}>{t("buyDue").toUpperCase()}
        </button>
        {/*<button
          disabled={disabled}
          type="submit"
          className="btn  btn-block bg-blue-t0 text-white-t0"
          onClick={() => onClick(isAgency, ActionPayment.payStoraged)}>{t("payNowStoraged").toUpperCase()}
        </button>*/}
        <button
          disabled={disabled}
          type="submit"
          className="btn  btn-block bg-blue-t0 text-white-t0 mb-5"
          onClick={() => onClick(isAgency, ActionPayment.pay)}>{t("payNow").toUpperCase()}
        </button>
      </div>
    )
  }
  return null
}

const HtmlTooltip = styled(({className, ...props}: TooltipProps) =>
  (
    <Tooltip {...props} classes={{popper: className}}/>
  ))(({theme}) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'red',
      maxWidth: 500,
      fontSize: '15px',
      border: '1px solid #dadde9',
    },
  }
));